// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LayoutOutlinedSvg from "@fishx/icons-svg/es/asn/LayoutOutlined";
import FishxIcon from '../components/FishxIcon';

var LayoutOutlined = function LayoutOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LayoutOutlinedSvg
  }));
};

LayoutOutlined.displayName = 'LayoutOutlined';
export default React.forwardRef(LayoutOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LayoutOutlined.js
// module id = 3011
// module chunks = 0